module.exports = __webpack_public_path__ + "static/search_screenshot-96212775719258bdd6ef5f67915ebf21.png";